module.exports = __webpack_public_path__ + "static/Bitmap-e747d5b290dcb377dcf6ce8fd5afe35b.png";